import React from 'react'
import { Sparkles, LineChart, BarChart3, Workflow, UsersRound, Bot, Building2 } from 'lucide-react'
import { Container, Eyebrow, SectionHeading } from '@/components/landing/design-system'
import FeatureGrid from '../FeatureGrid'
import { PHILOSOPHY } from '../data'
const ICONS = { Sparkles, LineChart, BarChart3, Workflow, UsersRound, Bot, Building2 }
export default function Philosophy() {
  return (
    <section className="relative py-24 md:py-28">
      <div className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-white/15 to-transparent" />
      <Container size="wide" className="flex flex-col gap-10">
        <div className="flex flex-col items-center text-center gap-5 max-w-3xl mx-auto">
          <Eyebrow>Trading Philosophy</Eyebrow>
          <SectionHeading align="center"
            title={<>Trading, done <span className="bg-gradient-to-r from-brand-gold to-[#FFE17A] bg-clip-text text-transparent">properly.</span></>}
            subtitle="Seven principles that shape every trading capability we ship. Contrast them with the fragmented workflows most desks tolerate today."
          />
        </div>
        <FeatureGrid items={PHILOSOPHY} icons={ICONS} cols={4} />
      </Container>
    </section>
  )
}
